<template>
  <el-dialog title="Remover da rota" :append-to-body="true" center :visible.sync="dialog" width="80%">
    <el-form>
      <el-form-item label="Rota">
        <el-select v-model="ruleForm.markers">
          <el-option v-for="item in tableMarkers" :key="item.id" :label="item.formatted" :value="item.id">
            <span style="float: left">{{ item.name }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.formatted }}</span>
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="default" @click.stop.prevent="dialog = false">Cancelar</el-button>
      <el-button type="primary" @click.stop.prevent="add">Remover</el-button>
    </span>
  </el-dialog>      
</template>

<script>
import { RouteService } from "@/services/umov/route.services";
export default {
  name: "RemoveRouteDestination",
  data() {
    return {
      ruleForm: {
        markers: "",
      },
      dialog: false,
      id: "",
      tableMarkers: [],
    }
  },
  methods: {
    updated(customer) {
      this.ruleForm.customer = customer;
    },
    selected(address) {
      this.ruleForm.address = address;
    },
    fetch() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      RouteService.get(vm.id)
        .then((response) => {
          vm.tableMarkers = response.markers.filter(x => x.status === "waiting");
          vm.dialog = true;
        })
        .catch((error) => {
          return this.$message({ type: "error", duration: 5000, message: error });
        })
        .finally(() => loading.close());
    },
    add() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      RouteService.removeCustomer(vm.ruleForm.markers)
        .then((response) => {
          this.dialog = false;
          vm.$message({
            type: "success",
            message: "Endereço removido com sucesso",
          });
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    open(id) {
      console.log('transfer open');
      this.id = id;
      this.fetch();
    }
  },
}
</script>